export const ANIMATION_DELAY_STEPS = 0.07;
